import React from 'react'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { Link as RouterLink } from 'react-router-dom'
import { getEventsForDay, formatTime } from './utils'
import { stringToColor } from 'lib/string-to-color'

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export default function MobileAgenda({ days, events }) {
  const hasAny = events.length > 0

  if (!hasAny) {
    return (
      <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
        <Typography>No lessons scheduled this week</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {days.map(day => {
        const dayEvents = getEventsForDay(events, day)
        if (dayEvents.length === 0) return null

        return (
          <Box key={day.toISOString()}>
            <Typography
              variant="subtitle2"
              sx={{ px: 2, pt: 2, pb: 0.5, fontWeight: 600, color: 'text.secondary' }}
            >
              {DAY_NAMES[day.getDay()]}, {MONTH_NAMES[day.getMonth()]} {day.getDate()}
            </Typography>
            <List dense disablePadding>
              {dayEvents
                .sort((a, b) => new Date(a.from) - new Date(b.from))
                .map(event => (
                  <ListItem key={event.id} disablePadding>
                    <ListItemButton
                      component={RouterLink}
                      to={`/groups/details/${event.groupId}/lesson/${event.id}`}
                      sx={{ px: 2 }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: stringToColor(event.teacher),
                          mr: 1.5,
                          flexShrink: 0,
                        }}
                      />
                      <ListItemText
                        primary={event.group}
                        secondary={`${event.teacher} \u00B7 ${formatTime(event.from)} \u2013 ${formatTime(event.to)}`}
                        primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                        secondaryTypographyProps={{ variant: 'caption' }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
            <Divider />
          </Box>
        )
      })}
    </Box>
  )
}
